import styled from "styled-components";

export const GrantAnnualWrap = styled.div`
  margin-bottom: 50px;
`;

export const RemainingBannerWrap = styled.div`
  margin: 30px 0 50px 0;
  display: ${props => props.displayType};
  justify-content: space-between;
  background-color: #f2f2f2;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    border-top: 6px solid #e37222;
  }
`;

export const RemainingBannerExceed = styled.div`
  display: ${props => props.displayType};
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    border-top: 6px solid #e37222;
  }
`;

export const RemainingBanner = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  color: #505050;
  padding: 25px 0 25px 30px;
  border-left: 6px solid #e37222;
  background-color: #f2f2f2;
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    border-left: none;
    padding: 25px 0 25px 20px;
  }
`;

export const RemainingBannerDisplay = styled(RemainingBanner)`
  display: flex;
  justify-content: space-between;
`;

export const CloseImage = styled.img`
  width: 25px;
  height: 25px;
  box-sizing: content-box;
  background-color: #f2f2f2;
  padding-right: 30px;
  cursor: pointer;
`;

export const UnderLine = styled.span`
  color: #505050;
  text-decoration: underline;
  cursor: pointer;
`;
